<template>
  <transition name="fade">
    <dialog ref="cookieBanner" class="cookie-banner" v-if="visible">
        <div class="popup animated fade-in">
            <div class="popup_background animated slide-in-up">
                <div class="popup-box">
                    <div class="popup-content container-fluid">
                        <div class="row">
                            <div class="col-xs-12 col-sm-10 col-sm-push-1">
                                <h4 class="title">{{ this.cookie_banner.headline }}</h4>
                                <p v-html="this.cookie_banner.text"></p>

                                <div class="col-xs-12 no-padding popup-choices">
                                    <div class="checkbox checkbox-he checkbox-disabled no-padding col-xs-6">
                                        <input :v-model="cookies.essentialAccepted" id="consent-functional"
                                               type="checkbox" checked disabled>
                                        <label id="necessary_cookies"
                                               for="consent-functional">{{ this.cookie_banner.neccessary }}</label>
                                    </div>
                                    <div class="checkbox checkbox-he padding-left-5 no-padding col-xs-6">
                                        <input v-model="cookies.statisticAccepted" id="cookies_statistic_accepted"
                                               type="checkbox">
                                        <label for="cookies_statistic_accepted">{{
                                                this.cookie_banner.statistics
                                            }}</label>
                                    </div>
                                    <div class="checkbox checkbox-he no-padding col-xs-6">
                                        <input v-model="cookies.serviceAccepted" id="cookies_service_accepted"
                                               type="checkbox">
                                        <label for="cookies_service_accepted">{{ this.cookie_banner.service }}</label>
                                    </div>
                                    <div class="checkbox checkbox-he padding-left-5 no-padding col-xs-6">
                                        <input v-model="cookies.marketingAccepted" id="cookies_marketing_accepted"
                                               type="checkbox">
                                        <label for="cookies_marketing_accepted">{{
                                                this.cookie_banner.marketing
                                            }}</label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-10 col-sm-push-1 top-margin">
                                <button id="agree" v-on:click="saveCookies(true)"
                                        class="btn btn-cookie-primary btn-primary bottom-buffer col-xs-12 no-margin-right cookie-btn">
                                    {{ this.cookie_banner.save_all }}
                                </button>
                                <button id="saveChoice" v-on:click="saveCookies(false)"
                                        class="btn btn-cookie-primary btn-primary bottom-buffer col-xs-12 no-margin-right cookie-btn">
                                    {{ this.cookie_banner.save_choice }}
                                </button>
                            </div>
                            <div class="col-xs-12 col-sm-10 col-sm-push-1 details-wrapper bottom-buffer-sm text-center">
                                <a href="#show" role="button" class="details collapsed" data-toggle="collapse"
                                   data-target="#hide1">{{ this.cookie_banner.show_details }}</a>
                            </div>
                        </div>

                        <div id="hide1" class="row collapse">
                            <div class="col-xs-12 col-sm-10 col-sm-push-1">
                                <h4>{{ this.details.headline }}</h4>
                                <template v-for="(item, index) in this.cookie_banner.details">
                                    <p v-html="index !== 'headline' ? item : '' " :key="'item-' + index"></p>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="popup-footer container-fluid">
                        <div class="row">

                            <div class="col-xs-12 text-center bottom-buffer-10">
                                <a :href="this.cookie_banner.imprint_link">{{ this.cookie_banner.imprint }} <span
                                    class="text-muted">|</span></a><a
                                :href="this.cookie_banner.policy_link"> {{ this.cookie_banner.policy }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </dialog>
    </transition>
</template>

<script>
import * as Cookies from "js-cookie";
import axios from 'axios';

const optInCookieName = 'tracking-accepted';
const optinCookieExpiryDays = 30;
const domain = window.location.hostname;
const ETRACKER_HASH = 'optimiser';

export default {
    name: "CookieBanner",
    data: function () {
        return {
            visible: false,
            locale: '',
            cookie_banner: [],
            details: '',
            browserLang: navigator.language,
            cookies: {
                essentialAccepted: true,
                statisticAccepted: false,
                serviceAccepted: false,
                marketingAccepted: false
            },
        }
    },
    methods: {
        generateJentisConsentData(allTrue = false) {
            const vendorSettings = {
                statistic: ['financeads', 'adcell', 'awin', 'mouseflow', 'cstm_crazy_egg', 'hubspot'],
                marketing: ['adwords', 'bing', 'cstm_brevo', 'facebook', 'leadfeeder', 'reddit_pixel'],
                service: ['cstm_trusted_shops']
            };

            const vendors = {};

            // Handle etracker explicitly based on statistic consent
            let etrackerConsent;
            if (allTrue) {
                etrackerConsent = true;
            } else {
                const selectedStatistic = !!this.cookies.statisticAccepted;
                etrackerConsent = selectedStatistic ? true : 'ncm';
            }
            vendors['etracker'] = etrackerConsent;
            Object.entries(vendorSettings).forEach(([category, vendorIds]) => {
                let consentValue = false;
                if (allTrue) {
                    consentValue = true;
                } else {
                    consentValue = !!this.cookies[category + 'Accepted'];
                }
                vendorIds.forEach(vendorId => {
                    vendors[vendorId] = consentValue;
                });
            });
            return JSON.stringify(vendors);
        },
        saveCookies: function (allCookies = false) {
            this.setCookies(allCookies);
            const domain = window.location.hostname;
            const baseDomain = domain.includes('.') ? domain.split('.').slice(-2).join('.') : domain;
            const vendorConsentData = JSON.parse(this.generateJentisConsentData(allCookies));
            Cookies.set('tracking-consent-data', JSON.stringify(vendorConsentData), {
                expires: optinCookieExpiryDays,
                domain: baseDomain,
                SameSite: 'None',
                secure: true
            });
            if (window.jentis?.consent?.engine) {
                if (typeof window.jentis.consent.engine.acceptAll === 'function' && allCookies) {
                    console.log('Calling Jentis native acceptAll() function.');
                    window.jentis.consent.engine.acceptAll();
                }
                this.closeAndReload();
            } else {
                console.warn('⚠️ Jentis is not yet available. Consent data could not be applied.');
                this.closeAndReload();
            }
        },
        closeAndReload: function () {
            this.closeBanner();
            location.reload();
        },
        setCookies(allCookies = false) {
            const baseDomain = domain.split(".").slice(-2).join(".");
            const cookieValues = {
                essentialAccepted: this.cookies.essentialAccepted,
                statisticAccepted: this.cookies.statisticAccepted,
                serviceAccepted: this.cookies.serviceAccepted,
                marketingAccepted: this.cookies.marketingAccepted
            };

            if (allCookies) {
                Object.keys(cookieValues).forEach(key => cookieValues[key] = true);
            }

            Cookies.set(optInCookieName, cookieValues, {
                expires: optinCookieExpiryDays,
                domain: baseDomain,
                SameSite: 'None',
                secure: true
            });

            const vendorConsentData = JSON.parse(this.generateJentisConsentData());
            if (allCookies) {
                Object.keys(vendorConsentData).forEach(key => {
                    vendorConsentData[key] = 'true';
                });
            }

            Cookies.set('tracking-consent-data', JSON.stringify(vendorConsentData), {
                expires: optinCookieExpiryDays,
                domain: baseDomain,
                SameSite: 'None',
                secure: true
            });
        },
        applyJentisConsentFromCookie() {
            const storedConsentData = Cookies.get('tracking-consent-data');
            if (storedConsentData) {
                try {
                    const parsedConsent = JSON.parse(storedConsentData);
                    if (window.jentis && window.jentis.consent && window.jentis.consent.engine) {
                        window.jentis.consent.engine.setNewVendorConsents(parsedConsent);
                        if (typeof window.jentis.event === 'function') {
                            window.jentis.event('consent_given');
                        }
                    } else {
                        console.warn('❌ Jentis consent engine is not available');
                    }
                } catch (e) {
                    console.error('❌ error in tracking-consent-data:', e);
                }
            }
        },
        openModal: function () {
            this.$refs.cookieBanner.showModal();
            this.toggleBodyClass();
        },
        openBanner() {
          this.visible = true;
        },
        closeBanner() {
          const dialog = this.$refs.cookieBanner;
          dialog.classList.add("fade-out");
          this.visible = false;
        },
        toggleBodyClass: function () {
            let body = document.getElementsByTagName('body')[0];
            if (body) {
                body.classList.toggle('stop-scrolling');
            }
        },
    },
    mounted: function () {
        const waitForJentis = () => {
            if (window.jentis?.consent?.engine) {
                this.applyJentisConsentFromCookie();
            } else {
                setTimeout(waitForJentis, 100);
            }
        };
        waitForJentis();
        // bypass etracker optimiser tool iframe
        let urlParams = new URLSearchParams(window.location.search);
        this.locale= window.locale;

        if (
            !Cookies.get(optInCookieName) &&
            urlParams.get('etracker') !== ETRACKER_HASH
        ) {
            this.openBanner();
        }

        let resetCookieBtn = document.getElementById('resetCookie');
        if (resetCookieBtn) {
            resetCookieBtn.addEventListener('click', () => {
                this.openBanner();
            });
        }
    },
    created: function() {
      let browserLang = navigator.language;
      let lang = '';
      if(browserLang.startsWith('de'))
        lang = '/de-de';
      else if(browserLang.startsWith('fr'))
        lang = '/fr-fr';
      else if(browserLang.startsWith('en'))
        lang = '/en-us';
      else lang = '/en-us';

      axios.post(lang+'/getCookieBannerText')
          .then(response => {
            this.cookie_banner = response.data.cookie_banner;
            this.details = response.data.cookie_banner.details;
          });
  }
}
</script>

<style scoped lang="scss">
@import "../../css/variables.scss";
.popup {
    background: rgba(0, 0, 0, .8);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    overflow: auto;
    display: flex;
    justify-content: center;
}
.popup_background{
  width: 473px;
  background-color: $color-lime-yellow;
  position: absolute;
  top:5%;
}
.popup-box {
    border-bottom-right-radius: 150px;
    background-color: $color-jungle-green;
    color: $color-white;
}

.popup-content {
    padding: 0 11px 15px;
    overflow: auto;
    max-height: 85vh;
}

.popup-footer {
    padding: 15px 10px 0;
    font-size: 13px;
}

.details-wrapper {
    margin-top: 1.5rem;
}

.title {
    margin-top: 1.5rem;
    font-size: 2.4rem;
}

#agree:hover {
    background-color: $color-dark-lime-yellow;
}

.popup-choices .checkbox {
    margin: 5px 0 0!important;
}

.details {
    color: $color-white;
}

.details.collapsed::before {
    content: "\E259";
}

.details::before {
    content: "\E260";
}

.details::before,
.details.collapsed::before {
    font-family: Glyphicons Halflings, sans-serif;
    padding-right: 10px;
}
a{
  color: $color-white;
}
.text-muted{
  color: $color-white;
}
.btn-cookie-primary {
  background-color: $color-lime-yellow;
  color: $color-jungle-green;
  &:focus, &:active, &:visited {
    box-shadow:  #f6fdc2;
    background-color: $color-dark-lime-yellow;
    color: $color-jungle-green;
    border-color: #f6fdc2;
  }
  &:hover{
    background-color: $color-dark-lime-yellow;
    color: $color-jungle-green;
  }
}


#necessary_cookies{
  opacity: .5;
}
@media (max-width: $xs-breakpoint-max) {
  .popup_background{
    width: 100%;
    background-color: $color-lime-yellow;
    position: absolute;
    top:5%;
  }
  .popup-box {
    border-bottom-right-radius: 150px;
  }
}

input[type="checkbox"] {
    appearance: none;
    background-color: $color-white;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    border-color: $color-white;
    border-radius: 0.25em;
    margin-top: 0.25em;
    opacity: initial;
    outline: none;

    &:disabled {
        opacity: 0.5;
    }

    &:checked {
        background-color: $color-gulf-green;
        border-color: $color-gulf-green;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3E%3C/svg%3E");
    }
}

@keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fade-out {
  from { opacity: 1; }
  to { opacity: 0; }
}

@keyframes slide-in-up {
  from { transform: translateY(20px); }
  to { transform: translateY(0); }
}

.cookie-banner {
  display: block;
}

.fade-in {
  animation: fade-in 0.3s ease-out;
}

.fade-out {
  animation: fade-out 0.3s ease-out;
}

.slide-in-up {
  animation: slide-in-up 0.3s ease-out;
}

.popup {
  display: flex;
  justify-content: center;
}


</style>
